export type RoleId = -1 | -2 | -3 | -4 | -5 | -6 | -7;

export const ADMIN_ROLE_ID: RoleId = -3;
export const SUPPORT_ROLE_ID: RoleId = -7;

export const RoleIdLabels: Record<RoleId, string> = {
  [-1]: "Veterinário",
  [-2]: "Assistente Veterinário",
  [-3]: "ADMIN",
  [-4]: "Grooming",
  [-5]: "Gestor Loja",
  [-6]: "Colaborador Loja",
  [-7]: "SUPORTE",
};

export type Employee = {
  id: number;
  name: string;
  serviceType: {
    id: number;
    value: string;
  };
};

export type AuthData = {
  id: number;
  email: string;
  name?: string;
  serviceTypeId: number;
  isActive: boolean;
  externalCode: string;
  roleId: RoleId;
  associatedStores?: string[];
};
